import { render, staticRenderFns } from "./LogoXL.vue?vue&type=template&id=55b1ccc8&"
import script from "./LogoXL.vue?vue&type=script&lang=js&"
export * from "./LogoXL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports